// CANONICAL COPY (GH #7115). src/constants/obligations/obl-dpo.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-dpo',
  title: 'Maintain Data Protection Officer appointment',
  description:
    'Where a Data Protection Officer is required under GDPR Article 37 — core activities consisting of regular and systematic monitoring of data subjects on a large scale, large-scale processing of special category data, or where mandated by Member State law — confirm that a DPO has been formally designated on the basis of professional qualities and expert knowledge of data protection law, that contact details are published and notified to the supervisory authority, and that the DPO reports to the highest level of management and is not instructed regarding the exercise of their tasks. Review the DPO appointment letter, independence safeguards and involvement in privacy decisions.',
  category: 'governance',
  scfIds: ['SCF-PRV-005'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    {
      type: 'dpo-designated',
      description:
        'A Data Protection Officer has been formally designated in the DPO module (name and appointment date recorded)',
    },
    { type: 'document-published', description: 'DPO appointment and charter are published' },
    { type: 'document-approved', description: 'Appointment has been approved' },
    { type: 'document-within-sla', description: 'Appointment / charter review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
